import { render, staticRenderFns } from "./DragHandleIcon.vue?vue&type=template&id=627ab467"
import script from "./DragHandleIcon.vue?vue&type=script&lang=js"
export * from "./DragHandleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports